import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api } from "@/lib/api";
import { Zap } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const MARQUEE_EN = [
  "⚡ 1 Day Trial @ ₹84 — Taste Before You Subscribe",
  "🥛 A2 GIR Cow Milk — ₹100/L",
  "🧈 Pure Bilona Ghee — Price on Call",
  "📦 Daily Delivery from 6 AM",
  "⭐ 2300+ Happy Families",
];

const MARQUEE_HI = [
  "⚡ पहले दिन ₹84 में आज़माएं",
  "🥛 A2 GIR दूध ₹100/लीटर",
  "🧈 शुद्ध बिलोना घी — मूल्य हेतु कॉल करें",
  "📦 प्रातः 6 बजे से डिलीवरी",
  "⭐ 2300+ संतुष्ट परिवार",
];

export default function OffersRibbon() {
  const [offers, setOffers] = useState([]);
  const { lang } = useI18n();
  useEffect(() => { api.get("/offers").then((r) => setOffers(r.data)).catch(() => {}); }, []);

  const items = lang === "hi" ? MARQUEE_HI : MARQUEE_EN;
  // If admin has added custom offers, mix them in front
  const activeCustom = offers.filter((o) => o.active && o.title);
  const all = [
    ...activeCustom.map((o) => `${o.title}${o.subtitle ? " · " + o.subtitle : ""}`),
    ...items,
  ];

  return (
    <div className="fixed top-[64px] md:top-[88px] inset-x-0 z-30 bg-gradient-to-r from-dd-gold to-[#8F6E28] text-dd-ink-dark py-2.5 border-b border-[#8F6E28]/50 shadow-md" data-testid="offers-ribbon">
      <Marquee speed={55} gradient={false} pauseOnHover>
        {all.concat(all).map((text, i) => (
          <span key={i} className="inline-flex items-center gap-2.5 text-sm font-medium mx-7 whitespace-nowrap">
            <Zap className="w-4 h-4" fill="currentColor" strokeWidth={0} />
            <strong>{text}</strong>
            <span className="mx-5 opacity-50">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
